import { Component, Input } from '@angular/core';

@Component({
  selector: 'bst-frontend-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css'],
})
export class CustomerDetailsComponent {
  @Input() orderBy: any;
}
